var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"picto-info-caution mdi mdi-alert",class:{ actif: _vm.value === true },attrs:{"title":_vm.value === true
      ? _vm.$t('poster.table.renderers.tainted_attribute.has_diff')
      : _vm.$t('poster.table.renderers.tainted_attribute.no_diff')}})
}
var staticRenderFns = []

export { render, staticRenderFns }